const utilsService = {
  formatDate(dateJson) {
    const date = new Date(dateJson);
    
    return date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
  },
};

export default utilsService;
